import { Component, OnInit, NgZone  } from '@angular/core';
import peopledata from './people_data.json';
import { ActivatedRoute, Router } from '@angular/router';
// import { MatDialog, MatDialogConfig } from '@angular/material';
// import { SalesforceConsultantComponent } from '../people/salesforce-consultant/salesforce-consultant.component';
import { OwlOptions } from 'ngx-owl-carousel-o';


@Component({
  selector: 'app-people',
  templateUrl: './people.component.html',
  styleUrls: ['./people.component.css']
})
export class PeopleComponent implements OnInit {

  public peopledata: { id: string, category: string, title: string, city: string, date: string, experience: string} [] = peopledata;
  selectedCategory = 'DEVELOPER';
  selectedCity = 'LISBON';
  selectedExperience = 'FULL';
  postsLimit = 4;
  isCategorySet = false;
  isExperienceSet = false;
  isCitySet = false;

  SliderOptions: OwlOptions = {
    // autoplay: true,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    nav: true,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      // 768: {
      //   items: 1
      // },
      // 1920: {
      //   items: 1
      // }
    },
  };

  constructor(
    private zone: NgZone,
    // private matDialog: MatDialog,
    private router: Router,
    // private route: ActivatedRoute,
    // private componentloader: SalesforceConsultantComponent
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    document.getElementById('people').style.backgroundColor = 'red';
    // console.log(peopledata);
    // console.log();
  }
  selectCategory(param) {
    // alert(param.target.value);
  if ( (param.target.value === 'default') && !(this.isCitySet) && !(this.isExperienceSet) ) {
      // alert('category all false');
      this.isCategorySet = false;
      this.isCitySet = false;
      this.isExperienceSet = false;
    } else if ( (param.target.value === 'ANALYST' || 'CONSULTING' || 'ENGINEER' || 'MANAGEMENT' || 'DEVELOPER') && !(this.isCitySet) && !(this.isExperienceSet) ) {
      this.selectedCategory = param.target.value;
      this.isCategorySet = true;
      this.isCitySet = false;
      this.isExperienceSet = false;
    } else if ( (param.target.value === 'ANALYST' || 'CONSULTING' || 'ENGINEER' || 'MANAGEMENT' || 'DEVELOPER') && (this.isCitySet) && !(this.isExperienceSet) ) {
      this.selectedCategory = param.target.value;
      this.selectedCity = this.selectedCity;
      this.isCategorySet = true;
      this.isCitySet = true;
      this.isExperienceSet = false;
    } else if ( (param.target.value === 'ANALYST' || 'CONSULTING' || 'ENGINEER' || 'MANAGEMENT' || 'DEVELOPER') && (this.isCitySet) && (this.isExperienceSet) ) {
      this.selectedCategory = param.target.value;
      this.isCategorySet = this.isCitySet = this.isExperienceSet = true;
    } else {
      return;
  }
  }

  selectCity(city) {
    if ( (city.target.value === 'default') && !(this.isCategorySet) && !(this.isExperienceSet) ) {
      // alert('city all false');
      this.isCategorySet = false;
      this.isCitySet = false;
      this.isExperienceSet = false;
    } else if ((city.target.value === 'PORTO' || 'LISBON' || 'AVEIRO') && !(this.isCategorySet) && !(this.isExperienceSet)) {
      this.selectedCity = city.target.value;
      this.isCitySet = true;
      this.isCategorySet = this.isExperienceSet = false;
    } else if ( (city.target.value === 'PORTO' || 'LISBON' || 'AVEIRO') && (this.isCategorySet) && !(this.isExperienceSet)) {
      this.selectedCity = city.target.value;
      this.selectedCategory = this.selectedCategory;
      this.isCitySet = this.isCategorySet = true;
      this.isExperienceSet = false;
    } else if ((city.target.value === 'PORTO' || 'LISBON' || 'AVEIRO') && (this.isCategorySet) && (this.isExperienceSet)) {
      this.selectedCity = city.target.value;
      this.selectedCategory = this.selectedCategory;
      this.selectedExperience = this.selectedExperience;
      this.isCitySet = this.isCategorySet = this.isExperienceSet = true;
    } else {
      return;
    }
  }
  selectExperience(exp) {
    if ( (exp.target.value === 'default') && !(this.isCategorySet) && !(this.isCitySet) ) {
      // alert('exp all false');
      this.isCategorySet = false;
      this.isCitySet = false;
      this.isExperienceSet = false;
    } else if ((exp.target.value === 'FULL' || 'SENIOR' || 'JUNIOR') && !(this.isCategorySet) && !(this.isCitySet)) {
      this.selectedExperience = exp.target.value;
      this.isCitySet = this.isCategorySet = false;
      this.isExperienceSet = true;
    } else if ((exp.target.value === 'FULL' || 'SENIOR' || 'JUNIOR') && (this.isCategorySet) && !(this.isCitySet)) {
      this.selectedExperience = exp.target.value;
      this.selectedCategory = this.selectedCategory;
      this.isCitySet = false;
      this.isCategorySet = this.isExperienceSet = true;
    } else if ((exp.target.value === 'FULL' || 'SENIOR' || 'JUNIOR') && (this.isCategorySet) && (this.isCitySet)) {
      this.selectedExperience = exp.target.value;
      this.selectedCategory = this.selectedCategory;
      this.selectedExperience = this.selectedExperience;
      this.isCitySet = this.isCategorySet = this.isExperienceSet = true;
    } else {
      return;
    }
  }

  // changeRoute() {
  //   this.zone.run( () => {
  //     this.router.navigate(['people/salesforceconsulting']);
  //   });
  // }
  // openJobDialog(id: string) {
  //   const dialogConfig = new MatDialogConfig();
  //   // // The user can't close the dialog by clicking outside its body
  //   // dialogConfig.disableClose = true;
  //   dialogConfig.id = 'modal-component';
  //   dialogConfig.height = '100%';
  //   dialogConfig.width = '100%';
  //   dialogConfig.maxWidth = '100vw';
  //   // dialogConfig.data = this.peopledata;
  //   const modalDialog = this.matDialog.open(SalesforceConsultantComponent, dialogConfig);
  //   this.componentloader.openSpecificJob(id);
  // }

  loadMore() {
    this.postsLimit = peopledata.length;
  }

  getEven(even) {
    // alert(even);
    if (even % 2 === 0 || even === 0) {
      return true;
    } else {
      return false;
    }
  }

  getOdd(odd) {
    // alert(odd);
    if (odd % 2 !== 0 || odd === 1) {
      return true;
    } else {
      return false;
    }
  }


}
